import {
    CREATE_ARCHITECTURESERVICE,
    RETRIEVE_ARCHITECTURESERVICE,
    RETRIEVESINGLE_ARCHITECTURESERVICE,
    UPDATE_ARCHITECTURESERVICE,
    DELETE_ARCHITECTURESERVICE,
  } from "../actions/type";
  const initialState = [];
  function ARCServiceReducer(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case CREATE_ARCHITECTURESERVICE:
        return {data: state.data, payload};
      case RETRIEVE_ARCHITECTURESERVICE:
        state = (payload.error == 1)?initialState:payload;
        return {data: state, payload};
      case RETRIEVESINGLE_ARCHITECTURESERVICE:
        state = (payload.error == 1)?initialState:payload;
        return {data: state.data, payload};
      case UPDATE_ARCHITECTURESERVICE:
        return {data: state.data, payload};
      case DELETE_ARCHITECTURESERVICE:
        return {data: state.data, payload};
      default:
        return state;
    }
  };
  export {ARCServiceReducer};